var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-180 52.2575 30.4422)",
    id: "svg_7",
    d: "m38.2575,30.40868l14,-13.95297l14,13.95297l-7,0l0,14.02011l-14,0l0,-14.02011l-7,0z",
    strokeWidth: 0,
    stroke: "#000",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    d: "m38.2575,70.4531l13.99999,-13.95298l14,13.95298l-7,0l0,14.02011l-13.99999,0l0,-14.02011l-7,0z",
    strokeWidth: 0,
    stroke: "#000",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_9",
    height: 7,
    width: 75,
    y: 46.5,
    x: 15,
    strokeWidth: 0,
    stroke: "#000",
    fill: "#DDDDDD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecenter);
export default __webpack_public_path__ + "static/media/recenter.d7403e6c37f0ee6a5bb6f4abc3869bfb.svg";
export { ForwardRef as ReactComponent };